import React from "react";

const InputDateComponent = ({ data, onInputChange }) => {
  const { required, label, inputKey } = data;

  return (
    <fieldset className="border border-light-grey-color w-full h-12 rounded-md mb-7">
      <legend className="mx-3 px-1 text-xs">
        {label} {required ? "*" : ""}
      </legend>
      <div className="flex flex-row justify-start text-sm text-Default items-center px-3">
        <input
          placeholder="Date of birth"
          type="text"
          onFocus={(e) => (e.target.type = "date")}
          id={inputKey}
          className="flex flex-row-reverse gap-2 mx-0 w-full border-0 placeholder:text-[#47556980] bg-transparent focus:outline-none placeholder:text-sm rounded-md px-2"
          name={inputKey}
          onChange={onInputChange}
        />
      </div>
    </fieldset>
  );
};

export default InputDateComponent;
